import { atom } from "recoil";
import { isMobile } from "react-device-detect";

import { persistAtom } from "./persist";
import { themeTwo as theme } from "../../theme/themeTwo";

export const SidebarExpandedState = atom({
  key: "SidebarExpanded_v1",
  default: !isMobile,
  effects_UNSTABLE: [
    ({ setSelf }) => {
      const checkScreenSize = () =>
        setSelf(!(window.innerWidth <= parseInt(theme.breaks.small)));

      checkScreenSize();

      window.addEventListener("resize", checkScreenSize);
      return () => window.removeEventListener("resize", checkScreenSize);
    },
    persistAtom,
  ],
});
